// extracted by mini-css-extract-plugin
export default {"availabilityBadge":"AvailabilityBadge-module_availabilityBadge__qU2I4","prohibited":"AvailabilityBadge-module_prohibited__vRr6L"};